import React from 'react';

export const ChevronLeft = ({style}) => (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" style={style}>
        <path d="M15.5246 20.344C15.1341 20.7344 14.501 20.7344 14.1106 20.3439L6.47456 12.7071C6.08409 12.3166 6.08409 11.6835 6.47456 11.2929L14.1106 3.65606C14.501 3.26555 15.1341 3.26554 15.5246 3.65602C15.9151 4.04647 15.9151 4.6795 15.5247 5.06998L9.30253 11.2929C8.91207 11.6835 8.91207 12.3166 9.30253 12.7071L15.5247 18.93C15.9151 19.3205 15.9151 19.9535 15.5246 20.344Z" fill="white"/>
    </svg>
)
